import { useLocation } from 'react-router-dom';

import { safeUrl, techSearchParams } from '#/service/utils';

import * as Styled from '../../Form.styled';

const Markdown = (props) => {
  const location = useLocation();

  const handleMarkupLink = (uri: string) => {
    // There will be a custom format for internal links.
    // See: https://accedobroadband.jira.com/browse/ACCEDOONECA-7164?focusedCommentId=1357018
    // In the meantime, we just hardcode this one, because HMN is already using it.
    // TODO: unhardcode when we have the specs.
    if (uri === 'accedooneca:TERMS_AND_CONDITIONS') {
      const searchParams = techSearchParams(location.search);
      const queryString = searchParams ? '?' + searchParams : '';
      uri = `/readme/terms${queryString}`;
    }

    return safeUrl(uri);
  };

  return <Styled.Markdown {...props} transformLinkUri={handleMarkupLink} />;
};

export default Markdown;
